let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hl8lH")).then(() => parcelRequire('foN6H'));